module.exports = __webpack_public_path__ + "static/media/API-VE.90e3ca80.pdf";